export default __webpack_public_path__ + "static/media/Vector_77.a58a7c8a.svg";